import { render, staticRenderFns } from "./FoodOrder.vue?vue&type=template&id=701566fe&scoped=true&"
import script from "./FoodOrder.vue?vue&type=script&lang=js&"
export * from "./FoodOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701566fe",
  null
  
)

export default component.exports